import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { handleResponseThrowError } from '@/_utils/services';
import type { PlacesInfosDashboardModalProps } from '../types';
import { GET_PLACE_CONFIG_INFOS_QUERY_KEY } from '@/_constants/keys';

type ParamsProps = {
  placeId: string;
};

const getPlaceDistributionRules = (params: ParamsProps) => {
  const { placeId } = params;

  return apiClient
    .get<PlacesInfosDashboardModalProps>(
      `/estabelecimentos/${placeId}/dashboard/distribution-rules`,
    )
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetDashboardInfosData = Awaited<
  ReturnType<typeof getPlaceDistributionRules>
>;

export const useGetPlaceDistributionRules = (
  params: ParamsProps,
  options: Omit<
    UseQueryOptions<
      GetDashboardInfosData,
      unknown,
      GetDashboardInfosData,
      (string | ParamsProps)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_PLACE_CONFIG_INFOS_QUERY_KEY, params],
    queryFn: () => getPlaceDistributionRules(params),
    ...options,
  });
};
